import React from "react";
import BrandWheelLoader from "../BrandWheelLoader";

// Gallery initial-load state (rendered by pages/Gallery/index.jsx while
// !initialLoadComplete). GROUNDED — Gordon's ask: "Gallery Loader should be the on
// brand Loader, Larger, and on a white background instead of on the Gallery skeleton."
//
// So this is now a clean WHITE field with a single LARGER on-brand BrandWheelLoader
// (the canonical Wheel filling — G-19: composed from brandWheelInner, never hand-rolled)
// centred, plus a quiet DM Sans caption so the wait reads as intentional. The old grey
// (#E8E8E8) MUI Skeleton mock-layout was removed entirely — no legacy path left behind.
//
// A11Y is carried by the shared loader: role=status + aria-live="polite" + aria-busy,
// the busy state announced once (the visible caption is aria-hidden), reduced-motion
// renders a still, COMPLETE Wheel at rest, and there is nothing focusable to trap.
// Export name/shape unchanged so pages/Gallery/index.jsx needs no change.
//
// #908 defect 2 (flash-to-blank): this is ALWAYS the very next thing on screen after
// routes.js's own <BrandWheelLoader variant="fullpage"> Suspense fallback — this
// component only ever mounts once its lazy route chunk has already resolved. That
// fallback and this one are still two separate component instances (Gallery's data
// fetch hasn't even started while the chunk is downloading), so without `skipEntry`
// this loader would restart its own whole-mark opacity fade from 0, which read as a
// blank white gap between "Loading iYuga…" and "Loading your Wheels…". `skipEntry`
// renders it already fully drawn from its first frame, so the handoff never dips.
//
// kelly-1003-P2-gallery-loading-white-circle-on-wallpaper: the loader's default
// white Portrait disc (brandWheelInner's `disc`) sits dead-centre of the viewport
// for the whole load — Kelly saw this as "a plain white circle ... centred". `disc`
// is the one knob BrandWheelLoader exposes for this; the multicolour jewel wedges
// still spin normally, only the white hub is dropped.
const GallerySkeleton = () => (
  <div
    style={{
      minHeight: "100vh",
      backgroundColor: "#FFFFFF",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <BrandWheelLoader
      variant="hero"
      label="Loading your Wheels…"
      caption="Loading your Wheels…"
      skipEntry
      disc={false}
    />
  </div>
);

export default GallerySkeleton;
